export default {"src":"/_next/static/media/circlePencil_24.01f82196.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};